import { UserOverview as OverviewPage } from '@/features/user/components/tabs/overview/Overview';

export default function Overview() {
  return <OverviewPage />;
}
